/**
 * tdesign v0.46.3
 * (c) 2022 tdesign
 * @license MIT
 */

var baseProps = {
  disabled: Boolean,
  color: {
    type: Object
  },
  handleChange: {
    type: Function,
    "default": function _default() {
      return function () {};
    }
  }
};

export { baseProps as default };
//# sourceMappingURL=base-props.js.map
